var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5679_26364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0801 2.23047L15.5632 6.71359",
    stroke: "#F66700",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32777 3.20762C7.12614 2.25868 4.46889 2.6828 2.67058 4.48168C2.30158 4.85068 1.99727 5.25793 1.74414 5.68768L4.33052 8.27293",
    stroke: "#F66700",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5901 8.45703C15.5587 10.666 15.1385 13.3345 13.3301 15.1429C12.9611 15.5119 12.5539 15.8162 12.1241 16.0693L9.5293 13.4745",
    stroke: "#F66700",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46744 14.6094L3.20312 10.3451C3.20312 10.3451 6.84587 1.28325 17.0626 0.75C16.4849 10.9228 7.46744 14.6094 7.46744 14.6094Z",
    stroke: "#F66700",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 15.375C0.75 14.4429 1.50544 13.6875 2.4375 13.6875C3.36956 13.6875 4.125 14.4429 4.125 15.375C4.125 16.3071 3.36956 17.0625 2.4375 17.0625C1.93688 17.0625 0.75 17.0625 0.75 17.0625C0.75 17.0625 0.75 15.8064 0.75 15.375Z",
    stroke: "#F66700",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 9.1875C10.8079 9.1875 11.4375 8.5579 11.4375 7.78125C11.4375 7.0046 10.8079 6.375 10.0312 6.375C9.2546 6.375 8.625 7.0046 8.625 7.78125C8.625 8.5579 9.2546 9.1875 10.0312 9.1875Z",
    stroke: "#F66700",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5679_26364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.69805e900874426a6e9ca6545aad0dc7.svg";
export { ForwardRef as ReactComponent };